import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import {MatSnackBar} from '@angular/material/snack-bar';
import {LoginService} from '@services/login/login.service';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [CommonModule, MatButton, MatIcon, MatCard, MatCardContent, MatCardHeader, MatCardTitle],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss'
})
export class AdminComponent {
  private loginService = inject(LoginService);
  private snackBar = inject(MatSnackBar);

  token: string | null = null;
  tokenVisible = false;

  constructor() {
    this.token = this.loginService.getToken();
  }

  toggleTokenVisibility() {
    this.tokenVisible = !this.tokenVisible;
  }

  copyToken() {
    if (this.token) {
      navigator.clipboard.writeText(this.token).then(() => {
        this.snackBar.open('Token copied to clipboard!', 'Close', {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
        });
      }).catch(() => {
        this.snackBar.open('Failed to copy token', 'Close', {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
        });
      });
    }
  }
}
